const RUNTIME_NAMESPACES = new Set([
  'audience',
  'audience_details',
  'audience_edit',
  'audiences',
  'axios',
  'data_source_details',
  'data_source_edit',
  'data_sources',
  'destinations',
  'settings',
  'sr_only',
  'topbar',
  'ui',
  'workspaces',
  'cyclr_integration_redirect',
  'checkbox',
  'company',
  'users',
  'build',
  'campaign',
  'home',
  'support',
  'layout',
  'unifiedProfile',
  'assistant',
  'traits',
  'COMMON',
  'localization',
  'errors',
  'ALL',
  'marketIntelligence',
  'help',
  'data_types',
  'server_errors',
  'time_elapsed',
  'status',
]);

export const toRuntimeTranslationKey = (key: string) => {
  if (key.includes(':')) {
    return key;
  }

  const namespaceSeparatorIndex = key.indexOf('.');

  if (namespaceSeparatorIndex === -1) {
    return key;
  }

  const namespace = key.slice(0, namespaceSeparatorIndex);

  if (!RUNTIME_NAMESPACES.has(namespace)) {
    return key;
  }

  return `${namespace}:${key.slice(namespaceSeparatorIndex + 1)}`;
};
